import { BillPayForm } from "./BillPayForm";

export const Initialize = () =>
{
	const newForm = new BillPayForm();
	newForm.Initialize();
}
